<template>
  <div>
    <div style="margin-bottom: 10px">
      <el-button type="primary" @click="$refs.warehouseEdit.open(0)">新建</el-button>
    </div>
    <Table 
        :loading="loading" 
        row-key="id" 
        border 
        :columns="columns" 
        :data="tableData">
      <template slot="action" slot-scope="{ row }">
        <el-button type="primary" @click="$refs.warehouseEdit.open(1, row)">编辑</el-button>
        <el-button v-if="row.level === 1" type="primary" :disabled="row.level === 3" @click="$refs.warehouseEdit.open(0, row)">
          添加下级
        </el-button>
        <el-button v-if="row.level === 2" type="primary" @click="$refs.warehouseEdit.open(0, row)">添加下级</el-button>
        <el-button type="danger" @click="deleteHandle(row)">删除</el-button>
      </template>
    </Table>
    <warehouse-edit ref="warehouseEdit" @save-success="getData"/>
    <warehouse-print ref="warehousePrint"/>
  </div>
</template>

<script>
  import WarehouseEdit from "./WarehouseEdit.vue";
  import WarehousePrint from "./WarehousePrint.vue";
  export default {
    name: "WarehouseNewList",
    components: {
      WarehouseEdit,
      WarehousePrint,
    },
    data() {
      return {
        columns: [
          {
            title: "编码",
            key: "other",
            width: 200,
            tree: true,
          },
          {
            title: "名称",
            key: "label",
          },
          {
            title: "外部编码",
            key: "other2",
            width: 200,
          },
          {
            title: "操作",
            width: 210,
            slot: "action",
          },
        ],
        tableData: [],
        loading: false,
        selection: [],
      };
    },

    mounted() {
      this.getData();
    },

    methods: {
      getData() {
        this.loading = true;
        this.$http
          .get("basic", "warehouses/tree")
          .then((res) => {
            if (res.success) {
              this.tableData = res.data;
              console.log(res.data);
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      },

      deleteHandle(row) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.delete("basic", "warehouses", row.id).then((res) => {
            if (res.success) {
              this.getData();
              this.$message.success("删除成功");
            }
          });
        });
      },
    },
  };
</script>

<style lang="scss">
.ivu-table td,
.ivu-table th {
  height: 37px;
  font-size: 13px;
  .el-button--mini {
    padding: 7px 10px;
  }
}
</style>
